import { createSlice, configureStore } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/dist/createAction";
import { ReceiptCheckItem } from "../../../../../domain/models/receipt-check";
import { Position } from "../../../../../domain/models/position-model";

type storeState = {
  items: ReceiptCheckItem[];
  currentItem: ReceiptCheckItem | null;
  position: Position | null;
};

const initialState: storeState = {
  items: [],
  currentItem: null,
  position: null,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    saveItems: (
      state,
      action: PayloadAction<{ items: ReceiptCheckItem[] }>
    ) => {
      state.items = action.payload.items;
    },
    setCurrentItem: (
      state,
      action: PayloadAction<{ item: ReceiptCheckItem }>
    ) => {
      state.currentItem = action.payload.item;
    },
    setPosition: (state, action: PayloadAction<{ position: Position }>) => {
      state.position = action.payload.position;
    },
  },
});

export const storeItemStore = configureStore({
  reducer: storeSlice.reducer,
});

export type StoreState = ReturnType<typeof storeItemStore.getState>;
export type StoreDispatch = typeof storeItemStore.dispatch;
export const storeActions = storeSlice.actions;
